(function () {
  'use strict';

  function initSection(section) {
    const sectionId = section.getAttribute('data-bundle-system-section');
    if (!sectionId) return;

    let currentOpenId = null;

    function openItem(desc, icon, toggle) {
      desc?.classList.add('open');
      icon?.classList.add('open');
      toggle?.setAttribute('aria-expanded', 'true');
      desc?.setAttribute('aria-hidden', 'false');
    }

    function closeItem(desc, icon, toggle) {
      desc?.classList.remove('open');
      icon?.classList.remove('open');
      toggle?.setAttribute('aria-expanded', 'false');
      desc?.setAttribute('aria-hidden', 'true');
    }

    function toggleBundleItem(itemIndex) {
      const descId = `desc-${sectionId}-${itemIndex}`;
      const iconId = `icon-${sectionId}-${itemIndex}`;
      const toggleId = `toggle-${sectionId}-${itemIndex}`;

      const desc = document.getElementById(descId);
      const icon = document.getElementById(iconId);
      const toggle = document.getElementById(toggleId);

      if (!desc || !icon || !toggle) return;

      if (currentOpenId === itemIndex) {
        closeItem(desc, icon, toggle);
        currentOpenId = null;
        return;
      }

      if (currentOpenId !== null) {
        const prevDesc = document.getElementById(`desc-${sectionId}-${currentOpenId}`);
        const prevIcon = document.getElementById(`icon-${sectionId}-${currentOpenId}`);
        const prevToggle = document.getElementById(`toggle-${sectionId}-${currentOpenId}`);

        if (prevDesc && prevIcon && prevToggle) {
          closeItem(prevDesc, prevIcon, prevToggle);
        }
      }

      openItem(desc, icon, toggle);
      currentOpenId = itemIndex;
    }

    section.addEventListener('click', function (e) {
      const toggleBtn = e.target.closest('.bundle-system__toggle-btn');
      if (!toggleBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const sectionIdParam = toggleBtn.getAttribute('data-section-id');
      const itemIndex = parseInt(toggleBtn.getAttribute('data-item-index'), 10);

      if (sectionIdParam === sectionId && !isNaN(itemIndex)) {
        toggleBundleItem(itemIndex);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-bundle-system-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
